"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _slate = require("slate");

var _slateReact = require("slate-react");

var _serializer = require("./serializer");

var _components = require("./components");

var _antd = require("antd");

var _icons = require("@ant-design/icons");

require("./style.less");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var CustomTextArea = function CustomTextArea(_ref) {
  var intl = _ref.intl,
      className = _ref.className,
      value = _ref.value,
      placeholder = _ref.placeholder,
      onChange = _ref.onChange,
      _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? true : _ref$fullWidth,
      _ref$supportImages = _ref.supportImages,
      supportImages = _ref$supportImages === void 0 ? false : _ref$supportImages,
      imageUploadUrl = _ref.imageUploadUrl,
      api_requests = _ref.api_requests,
      refreshAccessToken = _ref.refreshAccessToken,
      _ref$readOnly = _ref.readOnly,
      readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly;
  var editor = (0, _react.useMemo)(function () {
    return (0, _components.withImage)((0, _components.withLinks)((0, _slateReact.withReact)((0, _slate.createEditor)())));
  }, []);
  var renderElement = (0, _react.useCallback)(function (props) {
    return /*#__PURE__*/_react.default.createElement(_components.Element, props);
  }, []);
  var renderLeaf = (0, _react.useCallback)(function (props) {
    return /*#__PURE__*/_react.default.createElement(_components.Leaf, props);
  }, []); // Literally the initial value of 'value'

  var initialValue = (0, _react.useMemo)(function () {
    return value || '';
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var _useState = (0, _react.useState)((0, _serializer.deserialize)(initialValue) //tempValue
  ),
      _useState2 = _slicedToArray(_useState, 2),
      editorValue = _useState2[0],
      setEditorValue = _useState2[1];

  var notEmptyLink = function notEmptyLink(node) {
    return node.type !== 'link' || node.children[0].text !== "";
  };

  var cleanEmptyNodesChildren = function cleanEmptyNodesChildren(node) {
    if (node.type) {
      return node;
    }

    return _objectSpread(_objectSpread({}, node), {}, {
      children: node.children.map(function (child) {
        return (child.italic || child.bold) && child.text === "" ? _objectSpread(_objectSpread({}, child), {}, {
          italic: false,
          bold: false
        }) : child;
      })
    });
  };

  var handleChange = (0, _react.useCallback)(function (newEditorValue) {
    setEditorValue(newEditorValue);

    if (onChange) {
      var newValue = newEditorValue.filter(notEmptyLink).map(function (node) {
        return _objectSpread(_objectSpread({}, node), {}, {
          children: node.children.filter(notEmptyLink)
        });
      }).map(cleanEmptyNodesChildren).map(_serializer.serialize).join('\n');
      onChange(newValue);
    }
  }, [onChange]);
  return /*#__PURE__*/_react.default.createElement("section", {
    className: "CustomTextArea ".concat(fullWidth ? 'CustomTextArea__wide' : '', " ").concat(className || '')
  }, /*#__PURE__*/_react.default.createElement(_slateReact.Slate, {
    editor: editor,
    value: editorValue,
    onChange: handleChange
  }, !readOnly && /*#__PURE__*/_react.default.createElement(_components.Toolbar, null, /*#__PURE__*/_react.default.createElement(_components.MarkButton, {
    format: "bold",
    icon: /*#__PURE__*/_react.default.createElement(_icons.BoldOutlined, null)
  }), /*#__PURE__*/_react.default.createElement(_components.MarkButton, {
    format: "italic",
    icon: /*#__PURE__*/_react.default.createElement(_icons.ItalicOutlined, null)
  }), /*#__PURE__*/_react.default.createElement(_antd.Divider, {
    type: "vertical"
  }), /*#__PURE__*/_react.default.createElement(_components.BlockButton, {
    format: "numbered-list",
    icon: /*#__PURE__*/_react.default.createElement(_icons.OrderedListOutlined, null)
  }), /*#__PURE__*/_react.default.createElement(_components.BlockButton, {
    format: "bulleted-list",
    icon: /*#__PURE__*/_react.default.createElement(_icons.UnorderedListOutlined, null)
  }), /*#__PURE__*/_react.default.createElement(_antd.Divider, {
    type: "vertical"
  }), /*#__PURE__*/_react.default.createElement(_components.LinkButton, {
    icon: /*#__PURE__*/_react.default.createElement(_icons.LinkOutlined, null)
  }), supportImages && /*#__PURE__*/_react.default.createElement(_components.InsertImageButton, {
    icon: /*#__PURE__*/_react.default.createElement(_icons.PictureOutlined, null),
    uploadUrl: imageUploadUrl,
    api_requests: api_requests,
    refreshAccessToken: refreshAccessToken,
    intl: intl
  })), /*#__PURE__*/_react.default.createElement(_slateReact.Editable, {
    readOnly: readOnly,
    className: readOnly ? '' : "CustomTextArea__editor",
    renderElement: renderElement,
    renderLeaf: renderLeaf,
    placeholder: placeholder
  })));
};

var _default = CustomTextArea;
exports.default = _default;